import {
  Button,
  Card,
  CardContent,
  Input,
  Label,
  Popover,
  PopoverContent,
  PopoverTrigger,
  RadioGroup,
  RadioGroupItem,
  Separator,
} from '@ais-ui/ui-core';
import React, { useState } from 'react';
import { HumanOperator } from '../../Filters/constants';

interface FilterState {
  name: string;
  type: HumanOperator[];
}

interface FilterMenuProps {
  onApplyFilter: (
    column: string,
    operator: HumanOperator,
    value: string
  ) => void;
  filters: FilterState[];
}
export const FilterMenu = ({ onApplyFilter, filters }: FilterMenuProps) => {
  const [filterClicked, setFilterClicked] = useState<FilterState | null>(null);
  const [selectedFilterType, setSelectedFilterType] = useState<HumanOperator>(
    HumanOperator.Equal
  );
  const [filterValue, setFilterValue] = useState('');

  return (
    <Popover>
      <div className="text-sm font-medium">available filters</div>
      <div className="grid grid-cols-2 my-2 w-full">
        {filters.map((filter, index) => (
          <React.Fragment key={index}>
            <PopoverTrigger
              onClick={() => setFilterClicked(filter)}
              className="justify-self-start text-sm text-left cursor-pointer px-2 py-1 w-full hover:bg-secondary"
            >
              {filter.name.toLowerCase()}
            </PopoverTrigger>
          </React.Fragment>
        ))}
        {filters.length % 2 === 1 && (
          <PopoverTrigger className="cursor-default"></PopoverTrigger>
        )}
      </div>
      <PopoverContent
        side="right"
        align="end"
        sideOffset={20}
        alignOffset={-45}
        className="p-0 border-none shadow-none bg-transparent w-fit min-w-[128px]"
      >
        <Card className="h-42 w-min-64 w-full">
          <div className="px-4 py-2 flex justify-between items-center">
            <div className="font-medium pr-4">{filterClicked?.name}</div>
            <Button
              onClick={() =>
                onApplyFilter(
                  filterClicked?.name ? filterClicked.name : '',
                  selectedFilterType,
                  filterValue
                )
              }
            >
              Apply filter
            </Button>
          </div>
          <Separator className="w-7/8 mb-2 mx-2"></Separator>
          <CardContent className="px-4 pb-2">
            <RadioGroup defaultValue="equal to">
              {filterClicked?.type.map((filterType) => {
                const id = `${filterType}Id`;

                return (
                  <div className="py-1" key={filterType}>
                    <div className="flex items-center space-x-2">
                      <RadioGroupItem
                        value={filterType}
                        className="cursor-pointer"
                        id={id}
                        onClick={() => setSelectedFilterType(filterType)}
                      />
                      <Label htmlFor={id} className="cursor-pointer">
                        {filterType}
                      </Label>
                    </div>
                    {selectedFilterType === filterType && (
                      <Input
                        id={id}
                        className="h-8 mt-4"
                        placeholder="enter filter value"
                        autoComplete="off"
                        value={filterValue}
                        onChange={(event) =>
                          setFilterValue(event.currentTarget.value)
                        }
                      ></Input>
                    )}
                  </div>
                );
              })}
            </RadioGroup>
          </CardContent>
        </Card>
      </PopoverContent>
    </Popover>
  );
};
